import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { PollItemData } from '../../../models/PollItemData';
import { PollDashboardResponse } from '../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../shared/authentication.service';
import { LicenseService } from '../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../models/LicenseData';
import { Common } from '../../../shared/common';
import { Union } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-union',
  templateUrl: 'pap-union.component.html',
  styleUrls: ['./pap-union.component.less', '../../../shared/common.less'],
})

export class PapUnionComponent implements OnInit {
  @Input() unions: Union[] = [];
  @Output() unionsChange = new EventEmitter<Union[]>();

  needPap: boolean = undefined;

  constructor(
    private router: Router,
  ) {}
  
  onUnionChange() {
    this.unionsChange.emit(this.unions);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
